import { Box, CircularProgress, Container, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import EmployeeBasicInfo from '../components/EmployeeBasicInfo';
import Page from '../components/Page';

import SalesManagerDetailPageTabs from '../components/cardTabs/SalesManagerDetailPageTabs';
import PageHeader from '../components/smallComponents/PageHeader';

export default function ViewSalesManager() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [employee, setEmployee] = useState({});

  const getEmployee = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/employee`, {
        params: {
          id,
        },
      });
      console.log('employee', res);
      setEmployee(res.data.data?.employeeAccount);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmployee();
  }, [id]);

  return (
    <Page title="Sales Manager">
      {isLoading ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItem: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Container maxWidth="xl">
          <Stack direction="row" justifyContent="space-between" alignItems="center" marginBottom={4}>
            <PageHeader title="Sales Manager" />
          </Stack>
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Box id="basic-info" marginBottom={1}>
              <EmployeeBasicInfo getEmployee={getEmployee} employee={employee} />
            </Box>
            <SalesManagerDetailPageTabs salesManager={employee} />
          </Stack>
        </Container>
      )}
    </Page>
  );
}
